
export const apiUrl = 'https://busexpress.in/api';

export const config = {
    appName: 'BusExpress',
    apiUrl: apiUrl,
    timeout: 10000,
    retries: 3,
    maxSeatSelection: 6,
    baseUrl: 'https://busexpress.in',
    convenienceFee: 20,
    orderDuration: 360,
    contactDetails: {
        address: ' B8, Plot C2, Krishna Enclave, Kalwar Rd, Jaipur, Rajasthan 302012',
        phone: '+91-9257412279',
        helplineNo: '+91-9257412279',
        email: 'info@dextox.in',
    }
};
